import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import UploadSpecification from 'web/components/UploadSpecification';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import states from 'states-us';
import Button from 'web/components/Button';
import Spinner from 'web/components/Spinner';

import Select from 'web/components/form-elements/Select';
import AlertModal from 'web/components/AlertModal';
import { getInitialValues, VALIDATION_SCHEMA } from 'web/components/utils/editTaxExemptionUtils';

import styles from './tax-exemption.module.scss';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import styled from 'styled-components'
const EditTaxExemption = ({ isOpenTaxExm, toggleTaxExm, updateCallBack, uploadDocument, tabledata, fileArr, pageLanguageContents }) => {

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );

  const [hideShow, setHideShow] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [imageArrState, setImageArrState] = useState();
  const [editCheckFlag, setEditCheckFlag] = useState(false);

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = []
  for (let i = 0; i < territoryStates.length; i++) {
    if(territoryStates[i].name !=='District Of Columbia'){
      let obj = {
        value: territoryStates[i].name,
        label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
        isoCode: territoryStates[i].abbreviation
      }
      stateArr.push(obj)
    }
  }

  return (
    <div className={styles.addLocationContainer}>
      {loaderVisible && <Spinner />}
      <Modal
        isOpen={isOpenTaxExm}
        toggle={toggleTaxExm}
        backdrop={'static'}
        centered={true}
        className={styles.addLocation}>
        <div className={styles.header}>
          <Button handleClick={() => {
            setEditCheckFlag(false)
            toggleTaxExm(!isOpenTaxExm)
          }}>
            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
          </Button>
          <h3>Edit Tax Exemption</h3>
        </div>

        <ModalBody className={styles.body}>
          <Formik
            initialValues={getInitialValues(tabledata)}
            validationSchema={VALIDATION_SCHEMA}
            onSubmit={(values) => {
            }}>
            {(props) => {
              return (
                <>
                  <Form
                    className={hideShow === false ? styles.hide : styles.show}
                  >
                    <LocationGroup>
                      <div className="stateDiv">
                        <p className="mt-0">
                          {pageLanguageContents?.Tax_Exemption[3]?.State}
                          <span className='star'>&#42;</span>
                        </p>
                        <Select
                          name="editStateTaxExemption"
                          data={stateArr}
                          placeholder="State"
                          searchable={true}
                          disabled={true}
                          onChangeHandler={(data) => {
                          }}
                        />
                      </div>
                    </LocationGroup>

                    <LocationGroup>
                      <UploadSpecification
                        name="editTaxExemption"
                        props={props}
                        ProfileName=""
                        CompanyName=""
                        pageType=""
                        fileArr={fileArr}
                        imageArrState={imageArrState}
                        imageLoadCallBack={(imageArr) => { }}
                        callBackFun={(imageArr) => {
                          setImageArrState(imageArr);
                          uploadDocument(imageArr)
                        }}
                      />

                    </LocationGroup>
                    <LocationGroup>
                      <CheckboxInput
                        name="agreeCheckEdit"
                        label={pageLanguageContents?.Tax_Exemption[5]?.Date_Checkbox}
                        handleSelect={(val, label, flag) => {
                          setEditCheckFlag(flag);
                        }}
                      />
                    </LocationGroup>
                    <LocationGroup>
                      {editCheckFlag &&
                        <button
                          className="button app-green-button ml-auto"
                          onClick={(e) => {
                            if (imageArrState) {
                              updateCallBack(props)
                            } else {
                              setModalContent('Please upload a tax exemption form.');
                              setModalLink('');
                              toggleModal();
                            }
                          }}
                        >{pageLanguageContents?.Tax_Exemption[17]?.Clickbox}
                        </button>
                      }
                    </LocationGroup>
                  </Form>
                </>
              );
            }}
          </Formik>
        </ModalBody>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </div>
  );
};
export default EditTaxExemption;

const LocationGroup = styled.div`
  display: block;
  margin-bottom: 20px;
  .custom-file-input {
    max-width: 100%;
    ::before {
      width: 100%;
    }
  }
  .text {
    width: 100%;
  }
  label.uploadPhoto {
    max-width: 100%;
    width: auto;
    margin: 0 auto;
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
    margin-bottom: 20px;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    margin-bottom: 15px;
      .app-input-text {
        margin: 0;
      }
  }
`;